/**
 * XyObjectSlotX
 *
 * @param points - Array of growing points {x,y}.
 * @param options - Options.
 */
export function xyObjectSlotX(points, options = {}) {
    const { slotWidth = 1 } = options;
    const halfSlot = slotWidth / 2;
    // when we join we will use the center of mass
    const result = [];
    let current = {
        x: Number.NEGATIVE_INFINITY,
        y: 0,
    };
    for (const point of points) {
        const slot = point.x - ((point.x + halfSlot) % slotWidth) + halfSlot;
        if (Math.abs(current.x - slot) > Number.EPSILON) {
            current = {
                x: slot,
                y: 0,
            };
            result.push(current);
        }
        current.y += point.y;
    }
    return result;
}
//# sourceMappingURL=xyObjectSlotX.js.map